<script lang="ts">
	import { createSwitch, melt } from '@melt-ui/svelte';

	export let checked = false;
	export let disabled = false;
	export let name = '';
	export let value = '';
	export let required = false;
	export let id = name ?? Math.random().toString(36);
	let className = '';
	export { className as class };

	const {
		elements: { root, input },
		states: { checked: localChecked },
	} = createSwitch({
		disabled,
		name,
		value,
		required,
		onCheckedChange({ next }) {
			if (typeof next === 'boolean') {
				checked = next;
			}
			return next;
		},
	});

	$: $localChecked = checked;
</script>

<div class={className}>
	<!-- svelte-ignore a11y_consider_explicit_label -->
	<button
		class:bg-violet-600={checked}
		class:bg-gray-200={!checked}
		use:melt={$root}
		type="button"
		class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-violet-600 focus:ring-offset-2"
		role="switch"
		aria-checked={checked}
		{id}
		{...$$restProps}
	>
		<span
			aria-hidden="true"
			class:translate-x-5={$localChecked}
			class:translate-x-0={!$localChecked}
			class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
		></span>
	</button>
	<input {...$input} {id} use:$input.action value={checked} />
</div>
